import { GetPatientsBalanceResponse_PatientBalance } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { useTranslation } from '@frontend/i18n';
import { useMultiStepModal } from '@frontend/payments-multistep-modal';
import { useAppScopeStore } from '@frontend/scope';
import { Modal, Table, Text } from '@frontend/design-system';
import { useGenerateColumns } from '../../../../hooks/use-generate-columns';
import { CollectionColumn, generateColumns } from '../../common/generate-columns';
import { BULK_CREATE_STEPS } from '../bulk-create-steps-key-title';
import { Filters } from '../filters/filters';
import { useFilters } from '../filters/use-filters';

type NonSelectableUsersStepProps = {
  data: GetPatientsBalanceResponse_PatientBalance[];
};
export const NonSelectableUsersStep = ({ data }: NonSelectableUsersStepProps) => {
  const { t } = useTranslation('payments');
  const { selectedLocationIds } = useAppScopeStore();
  const columns = useGenerateColumns<CollectionColumn>(generateColumns, false, undefined, {
    hideLocationNameColumn: selectedLocationIds.length === 1,
  });

  // @ts-ignore
  const filteredCols = columns.filter((col) => col.id !== 'actions');

  const { goToStep } = useMultiStepModal();
  const { data: filteredPatients, handleFilterChange } = useFilters(data);

  return (
    <>
      <Modal.Body>
        <Text size='small'>
          {t("These balances can't receive Text-to-Pay links because they don't have a phone number on file.")}
        </Text>
        <Filters onChange={handleFilterChange} />
        <Table
          colConfig={filteredCols}
          data={filteredPatients ?? []}
          hasResponsiveColWidths
          isPaginated
          clientPaginationConfig={{
            defaultRowsPerPage: 7,
            rowsPerPageOptions: [7, 10, 20, 100],
            showNumRowSelector: true,
          }}
        />
      </Modal.Body>
      <Modal.Footer
        tertiary={{
          label: t('Back'),
          onClick: () => goToStep(BULK_CREATE_STEPS.VALIDATE_USERS.id),
        }}
      />
    </>
  );
};
